<template>
	<div id="bottomRight">
		<dv-border-box-6>
			<div class="d-flex pt-2 pl-2">
				<div class="d-flex">
					<span class="mt-3 ml-3 title_t">告警信息</span>
				</div>
			</div>
			<div class="d-flex jc-center body-box" v-if="config.data">
				<el-table :data="faultsList" highlight-current-row style="width: 90%;margin: 0 auto;" ref="table" height="0"
				@mouseenter.native="mouseEnter" @mouseleave.native="mouseLeave">
					<el-table-column prop="building_name" label="仓库" width="120" align="center"></el-table-column>
					<el-table-column prop="detail" label="故障信息" width="240" align="center"></el-table-column>
				</el-table>
				<!-- <dv-scroll-board :config="config" style="width: 4.2rem; height: 2.9rem;margin: 0 auto;" /> -->
			</div>
		</dv-border-box-6>
	</div>
</template>

<script>
	let rolltimer = '' // 自动滚动的定时任务
	export default {
		data() {
			return {
				config: {
					header: ["仓库", "故障信息"],
					data: [],
					rowNum: 6, //表格行数
					headerHeight: 30,
					headerBGC: "#085E7D", //表头
					oddRowBGC: "#0f1325", //奇数行
					evenRowBGC: "#171c33", //偶数行
					index: false,
					// columnWidth: [120],
					align: ["center", "center"],
				},
				faultsList: [],
				rollTime: 2,
				rollPx: 1,
			};
		},
		components: {},
		mounted() {
			this.faults();
			this.autoRoll()
		},
		methods: {
			async faults() {
				await this.$axios.get("/api/faults").then(res => {
					let faultsList = []
					for (let item of res.data.data) {
						faultsList.push([item.building_name, item.detail])
					}
					this.faultsList = res.data.data
					this.config = {
						header: ["仓库", "故障信息"],
						data: faultsList,
						rowNum: 6, //表格行数
						headerHeight: 30,
						headerBGC: "#085E7D", //表头
						oddRowBGC: "#0f1325", //奇数行
						evenRowBGC: "#171c33", //偶数行
						index: false,
						align: ["center", "center"],
					}
				})
			},
			autoRoll(stop) {
				if (stop) {
					clearInterval(rolltimer)
					return
				}

				// 拿到表格挂载后的真实DOM
				const table = this.$refs.table
				// 拿到表格中承载数据的div元素
				const divData = table.bodyWrapper
				// 拿到元素后，对元素进行定时增加距离顶部距离，实现滚动效果
				rolltimer = setInterval(() => {
					// 元素自增距离顶部像素
					divData.scrollTop += this.rollPx
					// 判断元素是否滚动到底部(可视高度+距离顶部=整个高度)
					if (divData.clientHeight + divData.scrollTop == divData.scrollHeight) {
						// 重置table距离顶部距离
						divData.scrollTop = 0
					}
				}, this.rollTime * 10)
			},
			// 鼠标进入
			mouseEnter() {
				// 鼠标进入停止滚动和切换的定时任务
				this.autoRoll(true)
			},
			// 鼠标离开
			mouseLeave() {
				// 开启
				this.autoRoll()
			},
		},
	};
</script>

<style lang="scss" scoped>
	#bottomRight {
		height: 3.9rem;
		width: 5.125rem;

		.body-box {
			height: 3rem;
			margin: 0.2rem auto 0;
		}
	}
	
	.el-table__body tr.current-row>td {
		background: linear-gradient(to bottom, #2C4257, rgba(0, 0, 0, 0), #2C4257) !important;
		border-top: 1px #5D90C2 solid;
		border-bottom: 1px #5D90C2 solid;
	}
</style>
